var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBellBoyList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 61,
    viewBox: "0 0 72 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4749 33.7379V37.0624C34.4749 37.5412 34.6289 38.0073 34.9142 38.3918C35.1994 38.7763 35.6008 39.0588 36.059 39.1977L39.9503 40.5218",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8565 33.7379V37.0624C18.8565 37.5412 18.7025 38.0073 18.4172 38.3918C18.1319 38.7763 17.7305 39.0588 17.2723 39.1977L6.80797 42.7141C5.10511 43.3503 3.63714 44.4914 2.60044 45.9846C1.56374 47.4779 1.00774 49.2521 1.00684 51.0699V53.3011",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8562 37.0623V40.775C20.9984 42.707 23.7807 43.7763 26.6654 43.7763C29.5501 43.7763 32.3324 42.707 34.4747 40.775V37.0645",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2784 18.0637C17.5179 16.2864 22.0688 15.3711 26.6657 15.3711C31.2626 15.3711 35.8135 16.2864 40.0529 18.0637",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2784 13.6012C17.5179 11.824 22.0688 10.9086 26.6657 10.9086C31.2626 10.9086 35.8135 11.824 40.0529 13.6012",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6658 37.6826V53.3011",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8015 47.723C32.9118 47.723 33.0196 47.7557 33.1113 47.817C33.2031 47.8783 33.2746 47.9654 33.3168 48.0674C33.359 48.1693 33.3701 48.2814 33.3485 48.3896C33.327 48.4978 33.2739 48.5972 33.1959 48.6752C33.1179 48.7533 33.0185 48.8064 32.9103 48.8279C32.8021 48.8494 32.6899 48.8384 32.588 48.7962C32.4861 48.7539 32.3989 48.6825 32.3377 48.5907C32.2764 48.499 32.2437 48.3911 32.2437 48.2808C32.2437 48.1329 32.3024 47.991 32.407 47.8864C32.5116 47.7818 32.6535 47.723 32.8015 47.723Z",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3188 29.8735C24.2212 30.7329 25.4196 31.2123 26.6657 31.2123C27.9118 31.2123 29.1101 30.7329 30.0125 29.8735",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4348 20.9486C24.1985 20.5784 23.8662 20.2791 23.4733 20.0826C23.0804 19.8862 22.6416 19.7999 22.2036 19.833C21.7656 19.7999 21.3268 19.8862 20.9339 20.0826C20.541 20.2791 20.2087 20.5784 19.9724 20.9486",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3591 20.9486C33.1228 20.5784 32.7905 20.2791 32.3976 20.0826C32.0047 19.8862 31.5659 19.7999 31.1279 19.833C30.6899 19.7999 30.2511 19.8862 29.8582 20.0826C29.4653 20.2791 29.1331 20.5784 28.8967 20.9486",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0529 19.8575V7.80903C40.0544 6.85825 39.7522 5.93186 39.1903 5.16488C38.6284 4.39789 37.8362 3.83043 36.9293 3.5452C30.2506 1.47346 23.1009 1.47346 16.4222 3.5452C15.5126 3.82656 14.7168 4.3915 14.1512 5.15745C13.5855 5.92339 13.2797 6.85018 13.2785 7.80234V19.8509C11.3886 20.8683 12.0022 25.1879 14.3941 26.2723C14.7269 26.4239 15.0174 26.6549 15.24 26.9452C15.4625 27.2354 15.6103 27.576 15.6703 27.9367C16.6587 33.8472 23.5799 37.6827 26.6657 37.6827C29.7604 37.6827 36.6794 33.8405 37.6633 27.9412C37.7233 27.5804 37.8711 27.2399 38.0937 26.9497C38.3162 26.6594 38.6067 26.4283 38.9396 26.2767C41.3314 25.1879 41.9428 20.8794 40.0529 19.8575Z",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6133 38.2914V26.5828C45.6133 25.8655 45.8982 25.1776 46.4054 24.6704C46.9126 24.1632 47.6006 23.8783 48.3179 23.8783H51.6986",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2214 23.8783H64.5447C65.262 23.8783 65.9499 24.1632 66.4571 24.6704C66.9643 25.1776 67.2493 25.8655 67.2493 26.5828V29.6136",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0146 48.2193H64.5448C65.2621 48.2193 65.95 47.9344 66.4572 47.4272C66.9644 46.92 67.2494 46.232 67.2494 45.5147V43.7267",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.13 36.6422C65.13 36.6422 64.5353 37.6699 64.6227 38.7463C64.7101 39.8227 66.0527 39.8552 66.0527 39.8552C66.0527 39.8552 65.1798 40.335 65.2897 41.6894C65.3997 43.0438 66.6877 43.6159 67.5712 43.5442C68.4547 43.4725 69.4074 43.4218 69.4074 43.4218C69.7286 43.3958 70.0237 43.2116 70.2278 42.9098C70.4319 42.608 70.5283 42.2133 70.4958 41.8126L70.7641 34.1863C70.7315 33.7856 70.5727 33.4116 70.3226 33.1467C70.0725 32.8818 69.7515 32.7476 69.4304 32.7736L66.1248 33.042C65.8036 33.0681 62.5357 33.2094 62.6899 35.1088C62.8441 37.0082 65.13 36.6422 65.13 36.6422Z",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8059 57.1317L54.2295 53.7081C55.074 52.8636 55.5485 51.7182 55.5485 50.5239C55.5485 49.3296 55.074 48.1842 54.2295 47.3397L52.6327 45.7428L56.0651 42.3104C56.4455 41.93 56.6592 41.414 56.6592 40.876C56.6592 40.3381 56.4455 39.8221 56.0651 39.4417C55.6847 39.0613 55.1688 38.8476 54.6308 38.8476C54.0928 38.8476 53.5769 39.0613 53.1965 39.4417L46.503 46.1352L46.3022 43.869C46.3316 43.4287 46.1876 42.9943 45.9011 42.6587C45.6145 42.3232 45.2081 42.1129 44.7686 42.073C44.3291 42.033 43.8915 42.1665 43.5491 42.4449C43.2067 42.7233 42.9868 43.1246 42.9363 43.563L39.8972 53.9595",
    stroke: "var(--primary-brand-color-dark, #679D2E)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBellBoyList);
export default __webpack_public_path__ + "static/media/Icon_bell_boy_list.916a650d.svg";
export { ForwardRef as ReactComponent };